/* eslint-disable no-undef */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import useScroll from 'customHooks/useScroll';
import logoDark from 'images/logoDark.svg';
import LoginSignupModal from 'pages/LoginSignup/components/LoginSignupModal/LoginSignupModal';
import { NavbarActions } from './NavbarActions';
import RedirectionButtons from '../RedirectionButtons/RedirectionButtons';

import './navbar-unlogged-desktop.scss';

const NavbarUnloggedDesktop = ({ isHomepage, isLoginPage, isSignupPage, isErrorPage }) => {
  const [loginSignupModalType, setLoginSignupModalType] = useState('');
  const [loginSignupModalVisible, setLoginSignupModalVisible] = useState(false);

  const { scrollY } = useScroll();

  const handleRedirection = (link) => {
    window.open(link, '_blank');
  };

  const toggleLogin = () => {
    setLoginSignupModalType('login');
    setLoginSignupModalVisible(true);
  };

  const toggleSignup = () => {
    setLoginSignupModalType('signup');
    setLoginSignupModalVisible(true);
  };

  return (
    <>
      <div
        className={classNames('navbar-unlogged-desktop', {
          'navbar-unlogged-desktop--homepage': isHomepage,
          'navbar-unlogged-desktop--homepage-scrolled': isHomepage && scrollY > 16,
        })}
      >
        <div className="d-flex align-items-center">
          <Link className="navbar-unlogged-desktop__logo" to="/" id="header_moonio-logo">
            <img src={logoDark} className="navbar--logo-img" alt="Heepsy's Logo" />
          </Link>
          {!isErrorPage && !isHomepage && <RedirectionButtons />}
        </div>
        {!isErrorPage && (
          <NavbarActions
            isHomepage={isHomepage}
            isLoginPage={isLoginPage}
            isSignupPage={isSignupPage}
            toggleLogin={toggleLogin}
            handleRedirection={handleRedirection}
            toggleSignup={toggleSignup}
          />
        )}
      </div>

      {!isSignupPage && !isLoginPage && (
        <LoginSignupModal
          visible={loginSignupModalVisible}
          closeModal={() => setLoginSignupModalVisible(false)}
          openModal={loginSignupModalType === 'signup' ? toggleLogin : toggleSignup}
          loginSignupModalType={loginSignupModalType}
        />
      )}

    </>
  );
};

export default React.memo(NavbarUnloggedDesktop);
